export const CommonRegex = {
	alphaEnglishWithSpecialCharacter: /^[a-zA-Z\s'\-.]*$/,
	visaFileNumber: /^\d{3}\/\d{4}\/\d+(\/\d+)*$/,
	emiratesId: /^(?!.*(\d)\1{11})\d+$/,
};
